
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as depot_45cvsA7SNgzhFESfnnfdUNZvSdkKtlxmzmevVER_Kg5rmosMeta } from "/vercel/path0/pages/depot-cv.vue?macro=true";
import { default as indexf7f_rHno77pVbVTcuc0OYu6LHtlP8ijd8jgfM_45YnbC8Meta } from "/vercel/path0/pages/ats/index.vue?macro=true";
import { default as indexj_45Cd5E381X3B_45WWjNKMfFijZT8I5iT0sfBUyk2D5YlMMeta } from "/vercel/path0/pages/jobs/index.vue?macro=true";
import { default as nos_45etudes_zqgxFhL13tlIRPVmVGYQWpoPv1v2fTzsbnRF1EaVd4Meta } from "/vercel/path0/pages/nos-etudes.vue?macro=true";
import { default as inscriptionEw541wMURxZIiTTmaWmRv8_jATTbqJ8TjHl4vn1p7JYMeta } from "/vercel/path0/pages/inscription.vue?macro=true";
import { default as maintenanceS2D_452B_kVL2s2_45Fnro7E5I4H1bMe8HzzSXmiOWH5i_UMeta } from "/vercel/path0/pages/maintenance.vue?macro=true";
import { default as cvtheque9HbTuzN4QFG29_45i89nVjQXAYWzPLF8QG_454Fnemx8kV0Meta } from "/vercel/path0/pages/ats/cvtheque.vue?macro=true";
import { default as nos_45partenairesRrH5CN_45ZskbkSa3zmOObil0p_45Z6Ucl93VQ2dhCJD14sMeta } from "/vercel/path0/pages/nos-partenaires.vue?macro=true";
import { default as ats_45profilpublicvllO1llIoiTPrACRGYS8SLHi2qn7Ov1aa_45Xgmgd6kEsMeta } from "/vercel/path0/pages/ats-profilpublic.vue?macro=true";
import { default as indexEhsZs2uhAUOZwbIbuhA4e3poHoeAiSHoUTj_olJDcXEMeta } from "/vercel/path0/pages/ats/offres/index.vue?macro=true";
import { default as index914PT0EM66cucCrg4JoVE_ChO6_453bSnYtbvLki3yj_454Meta } from "/vercel/path0/pages/employeurs/index.vue?macro=true";
import { default as mentions_45legaleswEe_ZMuCDXnbwZILRhDmI0vCIq7iUqJvdGGHhYJhj9YMeta } from "/vercel/path0/pages/mentions-legales.vue?macro=true";
import { default as indexVHSVyy0CkFKIlXtXx_VV8Hq_MMe4dYIMBFkgZlns2loMeta } from "/vercel/path0/pages/mon-profil/index.vue?macro=true";
import { default as presentation_45ats9evSCEvr_Etj2bfzN7bHwklx2szeX_DPBZ5SJ5452owMeta } from "/vercel/path0/pages/presentation-ats.vue?macro=true";
import { default as rhGXPsnkxxYPYwMlDn_JzFA8xb7bXDVUcDarDow8AeHMkMeta } from "/vercel/path0/pages/ats/parametres/rh.vue?macro=true";
import { default as _91slug_9383xG5KCmWyX1ZhBmmQuRmozxWrq47ugjL7O6jFttijUMeta } from "/vercel/path0/pages/employeurs/[slug].vue?macro=true";
import { default as indexbgBYHpPDBN3ODDS3qj2GYAFbeX26oJH4Fj1uLfnIM_kMeta } from "/vercel/path0/pages/jobs/[slug]/index.vue?macro=true";
import { default as compteKZfWVBE5McT0OPogJwHPwx_45PD_x6xHR_msYHCVCul98Meta } from "/vercel/path0/pages/mon-profil/compte.vue?macro=true";
import { default as _91id_93i0clgz80MQDuy7_sUgORqpMG6Dz4WjhAsLsrBKEEalMMeta } from "/vercel/path0/pages/ats/candidats/[id].vue?macro=true";
import { default as favoris5qQsmzbZv7YktOaJ9iV5C8pQOCojYs5kf_uu_45hGC_MUMeta } from "/vercel/path0/pages/mon-profil/favoris.vue?macro=true";
import { default as rgpdTY1uqLXmzMvLCuJsVlKNgAoDkI7_B2i9qs_45U9nUA0xwMeta } from "/vercel/path0/pages/ats/parametres/rgpd.vue?macro=true";
import { default as embedN83UjGUmriYxAfInSuA0bbphTa05Ckz0iFthVv_LcBsMeta } from "/vercel/path0/pages/career/[slug]/embed.vue?macro=true";
import { default as indexU4y2uuW7yObrLRfjVKeC5X2zVuxVBmuXQk4j0qqRa90Meta } from "/vercel/path0/pages/career/[slug]/index.vue?macro=true";
import { default as reunionsuVAxIUhwr_453FtnQ50mouwFgY3e_kRzlezk5PuqWFq6sMeta } from "/vercel/path0/pages/mon-profil/reunions.vue?macro=true";
import { default as indexkg_45cjdKiEiilmRB0apGKAVItDzt_45Pn_1cgQrjgkVHN8Meta } from "/vercel/path0/pages/ats/messagerie/index.vue?macro=true";
import { default as suiviQeGEF_XEmmqT1dfXR5C72q8bsUI3olQhHv1BRlFZuyYMeta } from "/vercel/path0/pages/ats/parametres/suivi.vue?macro=true";
import { default as conditions_45generales7hALFmD7GNNhyw2tYXmkJCaaO0Tb3nYWFvfXQpfZ_8sMeta } from "/vercel/path0/pages/conditions-generales.vue?macro=true";
import { default as postuler9ZO55AKCWf65B5zK1PthWgDFKLunztKso_6VcZt2_45SoMeta } from "/vercel/path0/pages/jobs/[slug]/postuler.vue?macro=true";
import { default as signature8B0dJZbzzPCdol_45LK9VlPgVm3s8GmTGjKHaxkq_45YJt8Meta } from "/vercel/path0/pages/mon-profil/signature.vue?macro=true";
import { default as politique_45de_45donneesaW7okiv5L_453bRr7UZcd_aLxuXZ3bgINYrJhrILINsa8Meta } from "/vercel/path0/pages/politique-de-donnees.vue?macro=true";
import { default as _91id_93CCaeKwgtS76WMkmx20ycUK_aWcsbEvt1v17zUdTA280Meta } from "/vercel/path0/pages/ats/candidatures/[id].vue?macro=true";
import { default as indexTF_45k_A7i9EfqM5N_Pvhs9_45ANLX1lBcI9_45YEQT1ibZh0Meta } from "/vercel/path0/pages/ats/offres/[id]/index.vue?macro=true";
import { default as offresHak6sCWZnLmbQrJdrkA9HS5s__453Ii7BmF5PCZSv5dykMeta } from "/vercel/path0/pages/ats/parametres/offres.vue?macro=true";
import { default as _91id_93B_45HNHhgoGcsnct__4555E_45Qq2g_45hL3Wpb434i6MVg0FBIMeta } from "/vercel/path0/pages/ats/candidats.old/[id].vue?macro=true";
import { default as modeles_OvIDtASDq4QDGtVssF1jdzyopDGKQApZFZPovlwLdgMeta } from "/vercel/path0/pages/ats/parametres/modeles.vue?macro=true";
import { default as indexP5X7NlL6B39FMM_45FdjZh3_454G4S4D9cVP6SpmBDxkLcsMeta } from "/vercel/path0/pages/ats/statistiques/index.vue?macro=true";
import { default as index0IpJ7uUVlMsCE5XUwtDb_CNcTjoVYDhYeByMaegcfkoMeta } from "/vercel/path0/pages/ats/candidats.old/index.vue?macro=true";
import { default as callbackwByEHHinA3MzqGJa90ZnQbZ_8JefIpPSsRLbZx2Q2wkMeta } from "/vercel/path0/pages/ats/messagerie/callback.vue?macro=true";
import { default as redirectxYqqmFPtu_GIwu9x6zqXlLu3wpHLoILlfjIsO7PzJtAMeta } from "/vercel/path0/pages/auth/microsoft/redirect.vue?macro=true";
import { default as candidaturesDtP_JxzFHbbGxg50QBL6_72Sgq3RLVpAP8Mc4VgY_458oMeta } from "/vercel/path0/pages/mon-profil/candidatures.vue?macro=true";
import { default as informationsf54ViDeY9jxyNbRhmEZlBj6PWwlDOYjvk0eiOumMQ7YMeta } from "/vercel/path0/pages/mon-profil/informations.vue?macro=true";
import { default as _91job_93W6dvx0iWvUGgLRwiPNr3WO0vQ7sA6VaJ8AqY7x8VeOQMeta } from "/vercel/path0/pages/career/[slug]/jobs/[job].vue?macro=true";
import { default as indexeszaj7_xH2cCu3ndMOjPEL2O8AVv7zh1Exs066bVFfIMeta } from "/vercel/path0/pages/career/[slug]/jobs/index.vue?macro=true";
import { default as notifications_45u0ouxeahrcvqx7UnxlSpay_45PFXT1r_mZ1ss2iBgpd4Meta } from "/vercel/path0/pages/mon-profil/notifications.vue?macro=true";
import { default as mon_45profil_5ha_OSB3UL8Gsf2K91r_45oiRo99x9tBgyb4hYe7qFLMMeta } from "/vercel/path0/pages/ats/parametres/mon-profil.vue?macro=true";
import { default as alertes_45emploiQfEoyJkIoOqhsCbZebrmRYLdB_5HClo6gkc2LdHQrmYMeta } from "/vercel/path0/pages/mon-profil/alertes-emploi.vue?macro=true";
import { default as formulairesvU22fmBAl_45fQkHxlNijFpekkwtDrq4AydbY7LKTOTcMMeta } from "/vercel/path0/pages/ats/parametres/formulaires.vue?macro=true";
import { default as page_45emploi_OULwEuOAMDxk37EB8SotRAryPiJVdp116fWBAifE7sMeta } from "/vercel/path0/pages/ats/parametres/page-emploi.vue?macro=true";
import { default as candidatures_45spontaneeszLxezwTQosECbHmNru1UHDMeeRyaTGWCNrgNoGFhdcAMeta } from "/vercel/path0/pages/ats/candidatures-spontanees.vue?macro=true";
import { default as organisationLY_N_45xnJSeIp9T907_4565UUaptChHwFjvYVRcdxrT22UMeta } from "/vercel/path0/pages/ats/parametres/organisation.vue?macro=true";
import { default as modification_45v67BsQPH79vJITOMG725dYj37aEBAE7eqzRGTxtpakMeta } from "/vercel/path0/pages/ats/offres/[id]/modification.vue?macro=true";
import { default as reunions_45callbacktD0lTmbOD1K3X3s_a5YRhxaxezv7qZOREa_N42Q3FtIMeta } from "/vercel/path0/pages/mon-profil/reunions-callback.vue?macro=true";
import { default as _91id_93Iej6r_kLM6aaxHd6_45qAaDRSA5mioOAAJ8gn4sR1pABMMeta } from "/vercel/path0/pages/ats/demandes-recrutement/[id].vue?macro=true";
import { default as collaborateurs25clCaqx0Lj_45Dik2IyPpMASQKZLVlOnto8ksA7nQJDsMeta } from "/vercel/path0/pages/ats/parametres/collaborateurs.vue?macro=true";
import { default as pv_45recrutementwxQLaUdkaPVnnfdnZi4r2kB19HMtx6a17VMwWNHBuFsMeta } from "/vercel/path0/pages/ats/parametres/pv-recrutement.vue?macro=true";
import { default as index5JG3hgkpSz_gXWxd8KU_45CB5szLHMw4hx4DTJl24J8A8Meta } from "/vercel/path0/pages/ats/demandes-recrutement/index.vue?macro=true";
import { default as mentions_45legales6vSABFQ8ibqmDuK8HcS5bHUBza73_453NIvmdofBrS4noMeta } from "/vercel/path0/pages/career/[slug]/mentions-legales.vue?macro=true";
import { default as demande_45recrutementFdwUjF4UXpDODlrP7mvM90O2pXsIfusuk1WE9_45S88ZkMeta } from "/vercel/path0/pages/ats/parametres/demande-recrutement.vue?macro=true";
import { default as _91id_931T9n333MzyHpILOXjrtOS01OKtpljSAN9CQXHN6J12oMeta } from "/vercel/path0/pages/ats/parametres/questionnaires/[id].vue?macro=true";
import { default as documentation_45iframeEpNXUUHtcHGofFQTGbNhAt_45O9v_AXhZu4yeu1hiIYeIMeta } from "/vercel/path0/pages/career/[slug]/documentation-iframe.vue?macro=true";
import { default as politique_45de_45donneesVmjGFb6hXngCM6ZX1kdCtDhE_45kTsMTYCPspErd2CgWsMeta } from "/vercel/path0/pages/career/[slug]/politique-de-donnees.vue?macro=true";
import { default as nouveaunkwF9hm_zTZ3CZKwbyg_ONHsFQ91Vp55WVWbXKlgEMcMeta } from "/vercel/path0/pages/ats/parametres/questionnaires/nouveau.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "depot-cv",
    path: "/depot-cv",
    meta: depot_45cvsA7SNgzhFESfnnfdUNZvSdkKtlxmzmevVER_Kg5rmosMeta || {},
    component: () => import("/vercel/path0/pages/depot-cv.vue")
  },
  {
    name: "ats",
    path: "/ats",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/ats/index.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/vercel/path0/pages/jobs/index.vue")
  },
  {
    name: "nos-etudes",
    path: "/nos-etudes",
    component: () => import("/vercel/path0/pages/nos-etudes.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: inscriptionEw541wMURxZIiTTmaWmRv8_jATTbqJ8TjHl4vn1p7JYMeta || {},
    component: () => import("/vercel/path0/pages/inscription.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceS2D_452B_kVL2s2_45Fnro7E5I4H1bMe8HzzSXmiOWH5i_UMeta || {},
    component: () => import("/vercel/path0/pages/maintenance.vue")
  },
  {
    name: "ats-cvtheque",
    path: "/ats/cvtheque",
    meta: cvtheque9HbTuzN4QFG29_45i89nVjQXAYWzPLF8QG_454Fnemx8kV0Meta || {},
    component: () => import("/vercel/path0/pages/ats/cvtheque.vue")
  },
  {
    name: "nos-partenaires",
    path: "/nos-partenaires",
    component: () => import("/vercel/path0/pages/nos-partenaires.vue")
  },
  {
    name: "ats-profilpublic",
    path: "/ats-profilpublic",
    meta: ats_45profilpublicvllO1llIoiTPrACRGYS8SLHi2qn7Ov1aa_45Xgmgd6kEsMeta || {},
    component: () => import("/vercel/path0/pages/ats-profilpublic.vue")
  },
  {
    name: "ats-offres",
    path: "/ats/offres",
    meta: indexEhsZs2uhAUOZwbIbuhA4e3poHoeAiSHoUTj_olJDcXEMeta || {},
    component: () => import("/vercel/path0/pages/ats/offres/index.vue")
  },
  {
    name: "employeurs",
    path: "/employeurs",
    component: () => import("/vercel/path0/pages/employeurs/index.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/vercel/path0/pages/mentions-legales.vue")
  },
  {
    name: "mon-profil",
    path: "/mon-profil",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/index.vue")
  },
  {
    name: "presentation-ats",
    path: "/presentation-ats",
    meta: presentation_45ats9evSCEvr_Etj2bfzN7bHwklx2szeX_DPBZ5SJ5452owMeta || {},
    component: () => import("/vercel/path0/pages/presentation-ats.vue")
  },
  {
    name: "ats-parametres-rh",
    path: "/ats/parametres/rh",
    meta: rhGXPsnkxxYPYwMlDn_JzFA8xb7bXDVUcDarDow8AeHMkMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/rh.vue")
  },
  {
    name: "employeurs-slug",
    path: "/employeurs/:slug()",
    component: () => import("/vercel/path0/pages/employeurs/[slug].vue")
  },
  {
    name: "jobs-slug",
    path: "/jobs/:slug()",
    component: () => import("/vercel/path0/pages/jobs/[slug]/index.vue")
  },
  {
    name: "mon-profil-compte",
    path: "/mon-profil/compte",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/compte.vue")
  },
  {
    name: "ats-candidats-id",
    path: "/ats/candidats/:id()",
    meta: { ...(_91id_93i0clgz80MQDuy7_sUgORqpMG6Dz4WjhAsLsrBKEEalMMeta || {}), ...{"middleware":["auth","ats"]} },
    component: () => import("/vercel/path0/pages/ats/candidats/[id].vue")
  },
  {
    name: "mon-profil-favoris",
    path: "/mon-profil/favoris",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/favoris.vue")
  },
  {
    name: "ats-parametres-rgpd",
    path: "/ats/parametres/rgpd",
    meta: rgpdTY1uqLXmzMvLCuJsVlKNgAoDkI7_B2i9qs_45U9nUA0xwMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/rgpd.vue")
  },
  {
    name: "career-slug-embed",
    path: "/career/:slug()/embed",
    meta: embedN83UjGUmriYxAfInSuA0bbphTa05Ckz0iFthVv_LcBsMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/embed.vue")
  },
  {
    name: "career-slug",
    path: "/career/:slug()",
    meta: indexU4y2uuW7yObrLRfjVKeC5X2zVuxVBmuXQk4j0qqRa90Meta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/index.vue")
  },
  {
    name: "mon-profil-reunions",
    path: "/mon-profil/reunions",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/mon-profil/reunions.vue")
  },
  {
    name: "ats-messagerie",
    path: "/ats/messagerie",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/ats/messagerie/index.vue")
  },
  {
    name: "ats-parametres-suivi",
    path: "/ats/parametres/suivi",
    meta: suiviQeGEF_XEmmqT1dfXR5C72q8bsUI3olQhHv1BRlFZuyYMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/suivi.vue")
  },
  {
    name: "conditions-generales",
    path: "/conditions-generales",
    component: () => import("/vercel/path0/pages/conditions-generales.vue")
  },
  {
    name: "jobs-slug-postuler",
    path: "/jobs/:slug()/postuler",
    meta: postuler9ZO55AKCWf65B5zK1PthWgDFKLunztKso_6VcZt2_45SoMeta || {},
    component: () => import("/vercel/path0/pages/jobs/[slug]/postuler.vue")
  },
  {
    name: "mon-profil-signature",
    path: "/mon-profil/signature",
    meta: signature8B0dJZbzzPCdol_45LK9VlPgVm3s8GmTGjKHaxkq_45YJt8Meta || {},
    component: () => import("/vercel/path0/pages/mon-profil/signature.vue")
  },
  {
    name: "politique-de-donnees",
    path: "/politique-de-donnees",
    component: () => import("/vercel/path0/pages/politique-de-donnees.vue")
  },
  {
    name: "ats-candidatures-id",
    path: "/ats/candidatures/:id()",
    meta: { ...(_91id_93CCaeKwgtS76WMkmx20ycUK_aWcsbEvt1v17zUdTA280Meta || {}), ...{"middleware":["auth","ats"]} },
    component: () => import("/vercel/path0/pages/ats/candidatures/[id].vue")
  },
  {
    name: "ats-offres-id",
    path: "/ats/offres/:id()",
    meta: { ...(indexTF_45k_A7i9EfqM5N_Pvhs9_45ANLX1lBcI9_45YEQT1ibZh0Meta || {}), ...{"middleware":["auth","ats"]} },
    component: () => import("/vercel/path0/pages/ats/offres/[id]/index.vue")
  },
  {
    name: "ats-parametres-offres",
    path: "/ats/parametres/offres",
    meta: offresHak6sCWZnLmbQrJdrkA9HS5s__453Ii7BmF5PCZSv5dykMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/offres.vue")
  },
  {
    name: "ats-candidats.old-id",
    path: "/ats/candidats.old/:id()",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/ats/candidats.old/[id].vue")
  },
  {
    name: "ats-parametres-modeles",
    path: "/ats/parametres/modeles",
    meta: modeles_OvIDtASDq4QDGtVssF1jdzyopDGKQApZFZPovlwLdgMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/modeles.vue")
  },
  {
    name: "ats-statistiques",
    path: "/ats/statistiques",
    meta: indexP5X7NlL6B39FMM_45FdjZh3_454G4S4D9cVP6SpmBDxkLcsMeta || {},
    component: () => import("/vercel/path0/pages/ats/statistiques/index.vue")
  },
  {
    name: "ats-candidats.old",
    path: "/ats/candidats.old",
    meta: index0IpJ7uUVlMsCE5XUwtDb_CNcTjoVYDhYeByMaegcfkoMeta || {},
    component: () => import("/vercel/path0/pages/ats/candidats.old/index.vue")
  },
  {
    name: "ats-messagerie-callback",
    path: "/ats/messagerie/callback",
    meta: { ...(callbackwByEHHinA3MzqGJa90ZnQbZ_8JefIpPSsRLbZx2Q2wkMeta || {}), ...{"middleware":["auth","ats"]} },
    component: () => import("/vercel/path0/pages/ats/messagerie/callback.vue")
  },
  {
    name: "auth-microsoft-redirect",
    path: "/auth/microsoft/redirect",
    component: () => import("/vercel/path0/pages/auth/microsoft/redirect.vue")
  },
  {
    name: "mon-profil-candidatures",
    path: "/mon-profil/candidatures",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/candidatures.vue")
  },
  {
    name: "mon-profil-informations",
    path: "/mon-profil/informations",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/informations.vue")
  },
  {
    name: "career-slug-jobs-job",
    path: "/career/:slug()/jobs/:job()",
    meta: _91job_93W6dvx0iWvUGgLRwiPNr3WO0vQ7sA6VaJ8AqY7x8VeOQMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/jobs/[job].vue")
  },
  {
    name: "career-slug-jobs",
    path: "/career/:slug()/jobs",
    meta: indexeszaj7_xH2cCu3ndMOjPEL2O8AVv7zh1Exs066bVFfIMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/jobs/index.vue")
  },
  {
    name: "mon-profil-notifications",
    path: "/mon-profil/notifications",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/mon-profil/notifications.vue")
  },
  {
    name: "ats-parametres-mon-profil",
    path: "/ats/parametres/mon-profil",
    meta: {"middleware":["auth","ats"]},
    component: () => import("/vercel/path0/pages/ats/parametres/mon-profil.vue")
  },
  {
    name: "mon-profil-alertes-emploi",
    path: "/mon-profil/alertes-emploi",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/mon-profil/alertes-emploi.vue")
  },
  {
    name: "ats-parametres-formulaires",
    path: "/ats/parametres/formulaires",
    meta: formulairesvU22fmBAl_45fQkHxlNijFpekkwtDrq4AydbY7LKTOTcMMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/formulaires.vue")
  },
  {
    name: "ats-parametres-page-emploi",
    path: "/ats/parametres/page-emploi",
    meta: page_45emploi_OULwEuOAMDxk37EB8SotRAryPiJVdp116fWBAifE7sMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/page-emploi.vue")
  },
  {
    name: "ats-candidatures-spontanees",
    path: "/ats/candidatures-spontanees",
    meta: candidatures_45spontaneeszLxezwTQosECbHmNru1UHDMeeRyaTGWCNrgNoGFhdcAMeta || {},
    component: () => import("/vercel/path0/pages/ats/candidatures-spontanees.vue")
  },
  {
    name: "ats-parametres-organisation",
    path: "/ats/parametres/organisation",
    meta: organisationLY_N_45xnJSeIp9T907_4565UUaptChHwFjvYVRcdxrT22UMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/organisation.vue")
  },
  {
    name: "ats-offres-id-modification",
    path: "/ats/offres/:id()/modification",
    meta: { ...(modification_45v67BsQPH79vJITOMG725dYj37aEBAE7eqzRGTxtpakMeta || {}), ...{"middleware":["auth","ats"]} },
    component: () => import("/vercel/path0/pages/ats/offres/[id]/modification.vue")
  },
  {
    name: "mon-profil-reunions-callback",
    path: "/mon-profil/reunions-callback",
    meta: { ...(reunions_45callbacktD0lTmbOD1K3X3s_a5YRhxaxezv7qZOREa_N42Q3FtIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/mon-profil/reunions-callback.vue")
  },
  {
    name: "ats-demandes-recrutement-id",
    path: "/ats/demandes-recrutement/:id()",
    meta: _91id_93Iej6r_kLM6aaxHd6_45qAaDRSA5mioOAAJ8gn4sR1pABMMeta || {},
    component: () => import("/vercel/path0/pages/ats/demandes-recrutement/[id].vue")
  },
  {
    name: "ats-parametres-collaborateurs",
    path: "/ats/parametres/collaborateurs",
    meta: collaborateurs25clCaqx0Lj_45Dik2IyPpMASQKZLVlOnto8ksA7nQJDsMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/collaborateurs.vue")
  },
  {
    name: "ats-parametres-pv-recrutement",
    path: "/ats/parametres/pv-recrutement",
    meta: pv_45recrutementwxQLaUdkaPVnnfdnZi4r2kB19HMtx6a17VMwWNHBuFsMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/pv-recrutement.vue")
  },
  {
    name: "ats-demandes-recrutement",
    path: "/ats/demandes-recrutement",
    meta: index5JG3hgkpSz_gXWxd8KU_45CB5szLHMw4hx4DTJl24J8A8Meta || {},
    component: () => import("/vercel/path0/pages/ats/demandes-recrutement/index.vue")
  },
  {
    name: "career-slug-mentions-legales",
    path: "/career/:slug()/mentions-legales",
    meta: mentions_45legales6vSABFQ8ibqmDuK8HcS5bHUBza73_453NIvmdofBrS4noMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/mentions-legales.vue")
  },
  {
    name: "ats-parametres-demande-recrutement",
    path: "/ats/parametres/demande-recrutement",
    meta: demande_45recrutementFdwUjF4UXpDODlrP7mvM90O2pXsIfusuk1WE9_45S88ZkMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/demande-recrutement.vue")
  },
  {
    name: "ats-parametres-questionnaires-id",
    path: "/ats/parametres/questionnaires/:id()",
    meta: _91id_931T9n333MzyHpILOXjrtOS01OKtpljSAN9CQXHN6J12oMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/questionnaires/[id].vue")
  },
  {
    name: "career-slug-documentation-iframe",
    path: "/career/:slug()/documentation-iframe",
    meta: documentation_45iframeEpNXUUHtcHGofFQTGbNhAt_45O9v_AXhZu4yeu1hiIYeIMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/documentation-iframe.vue")
  },
  {
    name: "career-slug-politique-de-donnees",
    path: "/career/:slug()/politique-de-donnees",
    meta: politique_45de_45donneesVmjGFb6hXngCM6ZX1kdCtDhE_45kTsMTYCPspErd2CgWsMeta || {},
    component: () => import("/vercel/path0/pages/career/[slug]/politique-de-donnees.vue")
  },
  {
    name: "ats-parametres-questionnaires-nouveau",
    path: "/ats/parametres/questionnaires/nouveau",
    meta: nouveaunkwF9hm_zTZ3CZKwbyg_ONHsFQ91Vp55WVWbXKlgEMcMeta || {},
    component: () => import("/vercel/path0/pages/ats/parametres/questionnaires/nouveau.vue")
  }
]